export enum OrderStatus {
    NEW = 0,
    ACCEPTED = 1,
    IN_PROGRESS = 2,
    COMPLETED = 3,
    CANCELED = 4,
    INVOICED_ORDERS = 5
}